import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    color: "#000",
    position: "relative",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    textAlign: "justify",
    flex: 1,
  },
  section: {
    margin: "12px 50px",
    fontFamily: "Helvetica",
  },
  text: {
    color: "#666",
    fontSize: "11px",
  },
  title: {
    fontSize: "16px",
    textAlign: "center",
    fontFamily: "Helvetica-Bold",
  },
  bodyText: {
    fontSize: "11px",
    marginBottom: "8px",
  },
});
